export default function PluginBody({ attr }) {
  const iframeStyle = {
    width: "1px",
    minWidth: "100%",
    minHeight: "500px",
    borderRadius: "18px",
    backgroundColor: "white",
    transition: "all 0.3s ease-in-out !important",
    border: "none",
  };

  const redBorder = {
    border: "1px solid red",
    textAlign: "center",
  };

  const variant = attr?.variation;

  const URL =
    attr?.variation === "iMakeable_single_calendar"
      ? `https://cal.imakeable.com/${attr?.userID}?isEmbeded=true`
      : `https://cal.imakeable.com/d/${attr?.organizationID}?isEmbeded=true`;

  if (variant === "iMakeable_single_calendar" && attr?.userID == false) {
    return (
      <div style={redBorder}>
        <p>
          Uzupełnij pole <i>Your client ID</i> w <strong>Ustawienia</strong> →{" "}
          <strong>iMakeable Cal plugin</strong>
        </p>
      </div>
    );
  } else if (variant === "iMakeable_main_calendar" && attr?.organizationID == false) {
    return (
      <div style={redBorder}>
        <p>
          Uzupełnij pole <i>Your organization ID</i> w <strong>Ustawienia</strong> →{" "}
          <strong>iMakeable Cal plugin</strong>
        </p>
        <code>Pamiętaj, ta opcja jest dostępna tylko do użtkowników premium</code>
      </div>
    );
  } else {
    return (
      <div>
        {attr?.userID ? (
          <>            
            <p>
              <iframe
                style={iframeStyle}
                id="meetIframe"
                src={URL}
                key="iframe-16"
                sandbox="allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation"
              ></iframe>
              <script
                dangerouslySetInnerHTML={{
                  __html: "iFrameResize({ checkOrigin: false }, '#meetIframe')",
                }}
              />
            </p>
          </>
        ) : (
          <p>Ładowanie...</p>
        )}
      </div>
    );
  }
}
